export default __webpack_public_path__ + "static/media/ComicBookGuy.389ae478.png";